
import React, { useState , useEffect} from "react";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import Payment from "../Myaccount/Payment";
import {updateSession , filebasepath , loaderBar , errorToast , successToast , apibaseURl , changeDateFotmate,  loggedInCustomerDetails , currencySymbol } from '../../functions/Function';

const  Withdraw = (props) => {
  const [data, setData] = useState({}); 
  const [inputs, setInputs] = useState({'user_id':loggedInCustomerDetails('id')});
  const [disabled, setDisabled] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [addRequest, setAddRequest] = useState(false);
  const [validation, setValidation] = useState(null);

  const handleClickAddRequest = () =>
  {
    setAddRequest(!addRequest);
    setInputs({'user_id':loggedInCustomerDetails('id')});
  }

  const timer = () => { 
    setTimeout(() => {
        setisLoading(false); 
  }, 1500);
}

const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }
const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    
    try {
      let res = await fetch(apibaseURl + "sendWalletRequest", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();

      setDisabled(false);
      if (res.status === 200) {
        
        if (output.result == true) {
              fetchData();
              setAddRequest(!addRequest);
              successToast('Your withdrawal request has been successfully submitted' , 'bottom-right' , 3000  , true);  
        }
        else if(output.validation == true)
          {
            errorToast(output.response.amount , 'bottom-right' , 3000  , true);
          }
        else
        {
              errorToast(output.response , 'bottom-right' , 3000  , true);
        } 

      }
    } catch (err) {
      setDisabled(false);
    }
  }

  const fetchData = () => {
    fetch(apibaseURl + "getWalletRequest/"+loggedInCustomerDetails('id'))
      .then(res => res.json())
      .then((result) => {
        
        if (result.status == true) {
            setData(result.response);
            timer()
       }
      }
      )
  }
  useEffect(() => {
       fetchData();
   }, [])
 


  

  return (
    <>
        <ToastContainer />
        <Payment />
        <div className="account-right-content-shdow mt-4">
            <h5 className="account-tab-heading">
             Withdraw Payment Request
            </h5>
            
            <div className="">
            {addRequest == false && 
              <>
              <div className="withdraw-header">
                  <h6 className="mt-2 mb-2">Withdraw Request History</h6>
                  <button className="btn btn-sm ivo-site-btn inline-btn mt-2 mb-2" onClick={()=>handleClickAddRequest()}  >Add Request</button>
              </div>
            
              <div className="trade-one-table-box trade-shadow-box">
                    <table className="table table-borderless final-table mb-0 ivo-table-responsive">
                    <thead>
                        <tr className="trade-tablke-header">
                            <th width={170+'px'} scope="col">Amount</th>
                            <th scope="col">Note</th>
                            <th scope="col">Status</th>
                            <th scope="col">Date </th>
                        </tr>
                    </thead>
                    <tbody>
                    {isLoading == true && 
                         <tr>
                             <td colSpan={5} className="text-center data-not-found">{loaderBar(100 , 25)}</td>
                        </tr>
                    }
                        {isLoading == false &&
                        <>
                            { Object.keys(data).length > 0  ? data.map((row, i) => (
                            <tr className="final-table-tr" key={i}>
                                
                                <td data-label="Amount">{currencySymbol()}{row.amount}</td>
                                <td data-label="Note" className="final-table-heading">
                                    <small className="text-dark">{row.note }</small>
                                </td>
                                <td  data-label="Status">
                                    {row.status == 'Pending' &&  <span className="badge badge-info" >Pending </span> }
                                    {row.status == 'Accept' &&  <span className="badge badge-success" >Accept </span> }
                                    {row.status == 'Reject' &&  <span className="badge badge-danger" >Reject </span> }
                                    
                                </td>
                               
                                <td data-label="Date">{changeDateFotmate(row.created_date , 'MMMM Do YYYY ')}</td>
                            </tr>
                            ))
                            : 
                            <tr>
                                  <td colSpan={5} className="text-center data-not-found">Data Not Found</td>
                            </tr>
                            }
                        </>
                        }
                        
                    </tbody>
                    </table>
              </div>
              </>
            }

              {addRequest == true && 
                <div>
                    <h6 className="text-center">Add Withdraw Request </h6>
                    <form method="POST" onSubmit={handleSubmit}>
                    <div className="form-group contact-form">
                      <div className="form-detail-icons">
                          <label>Amount</label>
                          <input
                                type="number"
                                name="amount"
                                value={inputs.amount || ""}
                                onChange={handleChange}
                                placeholder="Wallet Amount"
                                className="form-control my-form-control"
                                />
                          <div className="form-icon"><i className="fa-solid fa-wallet"></i></div>
                      </div>
                      <p className="not-found-text "> <small id="emailHelp" className="form-text text-danger">We'll never share your email with anyone else.</small></p>

                     

                    </div>
                
                    <div className="text-center">
                    
                      <button className="btn ivo-site-btn inline-btn" type="submit" disabled={disabled}> {disabled == false ? 'Send Request' : 'Sending...'} </button>
                      <button type="button" className="btn ivo-site-btn inline-btn ml-2" onClick={()=> handleClickAddRequest()}>Back</button>
                    </div>
                    </form>
                </div>
              }
            
      
            </div>          
        </div>       
    </>

  );
}

export default Withdraw;
